import * as XLSX from "xlsx";

export function s2ab(s: string) {
  const buf = new ArrayBuffer(s ? s.length : 0);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}

/**
 *
 * @param gridData
 * To download the user list in excel format
 * File columns: User Id, First Name, Last Name, Email Id, Roles, Organizations
 */
export const downloadUserListExcel = async (
  gridData: any,
  selectedIds: string[]
) => {
  /**Transofrming data for the file */
  const data = gridData
    ?.filter((user: any) => {
      if (selectedIds?.includes(user.userId) || selectedIds.length === 0) {
        return user;
      }
    })
    .map((user: any) => {
      if (!user) return {}; // To ensure `user` is not null or undefined before accessing its properties.

      return {
        "User Id": user.userId,
        "First Name": user.firstName,
        "Last Name": user.lastName,
        "Email Id": user.emailId,
        Roles: user?.roles?.map((role: any) => role?.name).join(", "),
        Organizations: user?.organization
          ?.map((org: any) => org?.name)
          ?.join(", "),
      };
    });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const binaryString = XLSX.write(workbook, {
    type: "binary",
    bookType: "xlsx",
  });

  if (binaryString) {
    const blob = new Blob([s2ab(binaryString)], {
      type: "application/octet-stream",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const currentDate = new Date().toISOString().slice(0, 10);
    link.download = `UDP_Admin-User-Management-${currentDate}.xlsx`;
    link.click();
    URL.revokeObjectURL(url);
  }
};
